import { render, staticRenderFns } from "./CustomerEditDialog.vue?vue&type=template&id=6621be4e"
import script from "./CustomerEditDialog.vue?vue&type=script&lang=js"
export * from "./CustomerEditDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditDialog.vue?vue&type=style&index=0&id=6621be4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports